// At every quarter (0, 15, 30, 45), issue a SCHEDULE_TICK. This event is useful
// for e.g. updating the current state based on a schedule.
// 15 minutes corresponds to the schedule granularity on the server.
export default store => {
  const QUARTER = 15 * 60 * 1000;

  const nextTickFromNow = () => {
    const now = Date.now();
    const next = Math.ceil(now / QUARTER) * QUARTER;
    console.log('Next SCHEDULE_TICK at', new Date(next));
    return next - now;
  };

  const tickDispatcher = () => {
    console.log('Now dispatching SCHEDULE_TICK at', new Date());
    store.dispatch({ type: 'SCHEDULE_TICK', timestamp: Date.now() });
    setTimeout(tickDispatcher, nextTickFromNow());
  };

  setTimeout(tickDispatcher, nextTickFromNow());
};
